module.exports = __webpack_public_path__ + "static/media/foodndrinks_mooring_marker.76c578ec.svg";